import { Link } from 'react-router-dom'
import { CreditCard, Clock, CheckCircle, AlertTriangle } from 'lucide-react'
import { useOrganization } from '../../hooks/useOrganization'
import type { SubscriptionStatus } from '../../lib/api'

function StatusBadge({ status }: { status: SubscriptionStatus }) {
  const config: Record<SubscriptionStatus, { label: string; className: string; icon: React.ReactNode }> = {
    active: { label: 'Activa', className: 'bg-emerald-100 text-emerald-700', icon: <CheckCircle className="w-3.5 h-3.5" /> },
    trialing: { label: 'Prueba', className: 'bg-sky-100 text-sky-700', icon: <Clock className="w-3.5 h-3.5" /> },
    past_due: { label: 'Pago pendiente', className: 'bg-amber-100 text-amber-700', icon: <AlertTriangle className="w-3.5 h-3.5" /> },
    incomplete: { label: 'Incompleta', className: 'bg-orange-100 text-orange-700', icon: <AlertTriangle className="w-3.5 h-3.5" /> },
    incomplete_expired: { label: 'Incompleta', className: 'bg-orange-100 text-orange-700', icon: <AlertTriangle className="w-3.5 h-3.5" /> },
    canceled: { label: 'Cancelada', className: 'bg-red-100 text-red-700', icon: <AlertTriangle className="w-3.5 h-3.5" /> },
    unpaid: { label: 'Sin pago', className: 'bg-red-100 text-red-700', icon: <AlertTriangle className="w-3.5 h-3.5" /> },
    paused: { label: 'Pausada', className: 'bg-slate-100 text-slate-600', icon: <Clock className="w-3.5 h-3.5" /> },
  }
  const { label, className, icon } = config[status] ?? { label: status, className: 'bg-slate-100 text-slate-600', icon: null }
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-sm font-medium ${className}`}>
      {icon}
      {label}
    </span>
  )
}

export function SettingsBillingSection() {
  const { org, isLoading, daysLeftInTrial } = useOrganization()

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <CreditCard className="w-5 h-5 text-slate-600" />
          <h2 className="text-lg font-semibold text-slate-800">Facturacion</h2>
        </div>
        <Link
          to="/billing"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors"
        >
          Gestionar facturacion
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-slate-500">Cargando...</p>
      ) : org ? (
        <div className="flex flex-wrap items-center gap-4">
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Plan</p>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-semibold bg-slate-100 text-slate-800 capitalize">
              {org.plan_id ?? 'starter'}
            </span>
          </div>
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Estado</p>
            <StatusBadge status={org.subscription_status} />
          </div>
          {org.subscription_status === 'trialing' && daysLeftInTrial !== null && (
            <div>
              <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Prueba</p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-sky-700">
                <Clock className="w-3.5 h-3.5" />
                {daysLeftInTrial} {daysLeftInTrial === 1 ? 'dia restante' : 'dias restantes'}
              </span>
            </div>
          )}
        </div>
      ) : (
        <p className="text-sm text-slate-500">No se pudo cargar la informacion de facturacion.</p>
      )}
    </div>
  )
}
